import React, { useEffect, useState } from 'react';
import { useExportToCSVMutation } from '../../store/api/exportApi';
import single from '../../assets/popup/Check.png';
const ExportCSV = ({ doctype, onClose , fieldsData }) => {
  const imageToShow =  single;
  const [showModal, setShowModal] = useState(false);
  const [exportCSV, { isLoading }] = useExportToCSVMutation();

  useEffect(() => {
    setShowModal(true); 
  }, []);

  const confirmDownload = async () => {
    setShowModal(false);
    try {
      const payload = {
        doctype: doctype, fields: fieldsData 
      }
      await exportCSV(payload).unwrap();
    } catch (error) {
      console.error("CSV export failed:", error);
     
    } finally {
      if (onClose) onClose(); 
    }
  };

  const cancelDownload = () => {
    setShowModal(false);
    if (onClose) onClose();
  };

  if (!showModal) return null;

  return (
    <>
      <div className="popup-overlay">
        <div className="popup-container">
          <button className="popup-close" onClick={cancelDownload}>×</button>
          <div className="blue-half-circle">
            <img src={imageToShow} alt="Popup Icon" className="popup-image" />
          </div>
          <div className="popup-content">
            <h4 style={{ color: '#823455' }}>Confirm Download</h4>
          </div>
          <div className="popup-content">
            <div className="popup-buttons">
            <button className="popup-btn cancel-btn" onClick={cancelDownload}>Cancel</button>
              <button className="popup-btn submit-btn"  onClick={confirmDownload}>Download</button>
            </div>
          </div>
        </div>
      </div>
    </>
   
  );
};

export default ExportCSV;
